<div id="successMdl" tabindex="-1">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content border-0">
            <div class="modal-body" style="border-radius: 20px">
                <div class="text-center">
                    <div class="d-flex justify-content-center">
                        <div style="width: 6rem; height: auto">
                          <span class="iconify" data-icon="carbon:information" style="font-size: 65px; color: #FFC50C;"></span>
                        </div>
                    </div>

                    <div class="text-center my-3">
                        <p>{{body}}</p>
                    </div>

                    <div class="my-3">
                        <button type="button" class="btn btn-warning" (click)="close()">
                            CLOSE
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


